import type { BackendModule } from "i18next";

export class I18nPackageBackendClient implements BackendModule {
  static type = "backend" as const;
  type = I18nPackageBackendClient.type;

  init() {}

  async read(language: string, namespace: string, callback: any) {
    const url = new URL(
      `../../../../../packages/i18n/src/messages/${language}.json`,
      import.meta.url,
    );

    try {
      const response = await fetch(url.href);
      const messages = await response.json();
      callback(null, messages);
    } catch (error) {
      callback(error, null);
    }
  }
}
